export default __webpack_public_path__ + "static/Plots0003-4b089be1644c8d5f039731ea5d8222cc.jpg";